var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-8"},[_c('vc-calendar',{attrs:{"attributes":_vm.attributes,"columns":_vm.$screens({ default: 1, sm: 2 }),"rows":_vm.$screens({ default: 1, sm: 2 }),"is-expanded":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }